export default "__VITE_ASSET__BBt2fNUp__"